import routes from '@rosebikes/public/assets/json/fos_js_routes.json';
import router from '@rosebikes/vendor/friendsofsymfony/jsrouting-bundle/Resources/public/js/router.min.js';

if (location.pathname.startsWith('/app_dev.php')) {
  routes.base_url = '/app_dev.php';
}

router.setRoutingData(routes);

export default router;